import type { FirebaseApp } from 'firebase/app';
import { getAuth, initializeAuth, browserLocalPersistence, inMemoryPersistence } from 'firebase/auth';
export function initializePlatformAuth(app: FirebaseApp, native: boolean, secureIOS = false) {
  // Native providers supply credentials directly. The web popup resolver
  // proactively loads an iframe on iOS and can stall WKWebView initialization.
  return native ? initializeAuth(app, {persistence: secureIOS ? inMemoryPersistence : browserLocalPersistence}) : getAuth(app);
}
